export const FLAG_GETTING_EXECUTION_REGISTRATIONS =
  'FLAG_GETTING_EXECUTION_REGISTRATIONS';
export const GET_EXECUTION_REGISTRATIONS = 'GET_EXECUTION_REGISTRATIONS';
export const CLEAR_EXECUTION_REGISTRATIONS = 'CLEAR_EXECUTION_REGISTRATIONS';
export const FLAG_EXECUTION_REGISTRATION_ACTIVITY =
  'FLAG_EXECUTION_REGISTRATION_ACTIVITY';
export const GET_EXECUTION_REGISTRATION = 'GET_EXECUTION_REGISTRATION';
export const CLEAR_EXECUTION_REGISTRATION = 'CLEAR_EXECUTION_REGISTRATION';
